<template>
	<div id="app_banner" class="home-banner dp-f">
		<div class="home-banner-eagle">
			<div class="eagle-pic">
				<img :src="currentBanner" />
			</div>

			<div class="eagle-buy dp-f">
				<a class="but-now" href="javascript:;">
					<e-button
						class="buy-now-button"
						type="primary"
						@click="freeTrialClick"
						round
						>{{ getConstants('BOXCRYPTOR_LANDING_COMMON_FREE') }}</e-button
					>
				</a>
				<a class="buy-detai" href="#app_sale">
					<e-button round>{{
						getConstants('BOXCRYPTOR_LANDING_BANNER_BUYNOW')
					}}</e-button>
				</a>
			</div>
		</div>
		<div class="home-banner-display">
			<img :src="appBanner.bannerDisplay" alt />
		</div>
	</div>
</template>
<script>
import buyStore from '../../../utils/buyStore'

export default {
	props: {
		appBanner: {
			type: Object,
			required: true,
		},
	},
	methods: {
		jumpToBenift() {
			Location.href = '#app_benifits'
		},

		freeTrialClick() {
			if (!this.PageInfo.accountState) {
				location.href = `/d/signup?next=/s/tutorial/${
					this.appBanner.pageName
				}?coupon_code=${buyStore.coupon.coupon_code}`
			} else {
				location.href = `/s/tutorial/${this.appBanner.pageName}?coupon_code=${
					buyStore.coupon.coupon_code
				}`
			}
		},
	},
	computed: {
		currentBanner() {
			return this.getConstants('LOCAL_LANGUAGE') === 'en'
				? this.appBanner.bannerEn
				: this.appBanner.bannerZh
		},
	},
}
</script>

<style lang="scss" scoped>
.home-banner {
	justify-content: center;
	flex-wrap: wrap;
	.home-banner-eagle {
		width: 500px;
		margin-top: 118px;
		margin-right: 16px;
		text-align: center;
		.eagle-pic {
			img {
				width: 500px;
				height: 250px;
			}
		}
	}
	.eagle-buy {
		margin-top: 40px;
		justify-content: flex-start;
		button {
			width: 120px;
			height: 40px;
		}
	}
	.buy-now-button {
		margin-right: 16px;
	}
	.home-banner-display {
		margin-top: 78px;
		text-align: center;
		img {
			width: 648px;
			height: 445px;
		}
	}
}
@media (max-width: 768px) and (min-width: 414px) {
	.home-banner {
		.home-banner-eagle {
			margin-right: 0;
			padding: 0 20px 0;
		}
	}
}

@media (max-width: 414px) {
	.home-banner {
		padding-top: 0;
		.home-banner-eagle {
			margin-top: 24px;
			margin-right: 0;
			padding: 0 20px 0;
			text-align: center;
			.eagle-pic {
				img {
					width: 288px;
					height: 144px;
				}
			}
		}
		.home-banner-display {
			margin-top: 40px;
			text-align: center;
			img {
				width: 288px;
				height: 198px;
			}
		}
		.eagle-buy {
			justify-content: center;
		}
	}
}
</style>
